import { ReactComponent as CloseIcon } from "/common/assets/images/close-icon.svg";
import { ReactComponent as TitleIcon } from "/common/assets/images/filter-icons/title-icon.svg";

import React, { useRef, useState } from "react";

import * as Styled from "common/components/SearchInput/SearchInput.styles";

interface SearchInputProps {
  value: string;
  onChanged: (text: string) => void;
  className?: string;
}

const SearchInput = ({ value, onChanged, className }: SearchInputProps) => {
  const debounce = useRef<NodeJS.Timeout>();
  const [inputValue, setInputValue] = useState(value);

  return (
    <Styled.Root className={className}>
      <Styled.SearchIcon style={{ marginRight: 6 }}>
        <TitleIcon />
      </Styled.SearchIcon>
      <Styled.TextInput
        maxLength={10000}
        value={inputValue}
        onChange={(e) => {
          const newValue = e.target.value;
          setInputValue(newValue);

          if (debounce.current) clearInterval(debounce.current);
          debounce.current = setTimeout(() => onChanged(newValue), 100);
        }}
      />
      {value.length > 0 ? (
        <Styled.ClearButton
          onClick={() => {
            setInputValue("");
            onChanged("");
          }}
        >
          <CloseIcon />
        </Styled.ClearButton>
      ) : null}
    </Styled.Root>
  );
};

export { SearchInput };
